import React from 'react'

import type { ResourceSchema } from '~/client/src/shared/resources/domain/resourceSchema'

import { CreateFormSidebar } from './CreateFormSidebar'
import { EditFormSidebar } from './EditFormSidebar'

interface IBaseFormPropertiesSidebarProps {
  resourceTypeId: string
  onClose: () => void
  // Renders a "Select" button at the bottom-left that returns to a picker
  // without saving. Used by inline picker-hosted creation flows.
  onBackToPicker?: () => void
  resourceSchema: ResourceSchema
}

interface ICreateFormPropertiesSidebarProps extends IBaseFormPropertiesSidebarProps {
  mode: 'create'
  // Fires after a successful create with the new template id. If omitted,
  // onClose runs instead — admin uses that fallback to dismiss the sidebar.
  onCreated?: (newTemplateId: string) => void | Promise<void>
}

interface IEditFormPropertiesSidebarProps extends IBaseFormPropertiesSidebarProps {
  mode: 'edit'
  templateId: string
}

type IFormPropertiesSidebarProps =
  | ICreateFormPropertiesSidebarProps
  | IEditFormPropertiesSidebarProps

const FormPropertiesSidebar: React.FC<IFormPropertiesSidebarProps> = props => {
  if (props.mode === 'create') {
    return (
      <CreateFormSidebar
        resourceTypeId={props.resourceTypeId}
        onClose={props.onClose}
        onBackToPicker={props.onBackToPicker}
        resourceSchema={props.resourceSchema}
        onCreated={props.onCreated ?? (() => props.onClose())}
      />
    )
  }

  return (
    <EditFormSidebar
      templateId={props.templateId}
      resourceTypeId={props.resourceTypeId}
      onClose={props.onClose}
      onBackToPicker={props.onBackToPicker}
      resourceSchema={props.resourceSchema}
    />
  )
}

export default FormPropertiesSidebar
